import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';
import { RichTextPropTypes } from '../../prop-types';
// Utils
import windowSize from '../../utils/window-size';
import { useLayout } from '../layout/context';
// Styles
import Accordion from '../accordion/accordion';
import SimpleRichText from '../rich-text/simple';
import { Container } from '../styled/containers';
import {
  BottomText,
  TextContainer,
  Title,
  Transcript,
  VideoContainer,
  VideoWrapper,
  Wrapper,
} from './styles';

const VideoEmbed = ({
  externalUrl,
  title,
  bottomText,
  removeMarginBottom,
  metaDescription,
  transcript,
  fullWidthLayout,
}) => {
  const { insideContainer, insideTwoThirds, insideHalfWidth } = useLayout();
  const { isClient, isDesktop } = windowSize();

  const narrowContainer = insideTwoThirds || insideHalfWidth;
  const fullWidth = fullWidthLayout || narrowContainer || !isDesktop;

  const options = {
    youtube: {
      playerVars: {
        controls: 1,
        autoplay: 0,
        modestbranding: 1,
      },
    },
  };

  return (
    <Container
      key={`vid-${isClient}`}
      $padding={!narrowContainer && !insideContainer}
    >
      <Wrapper
        $fullWidth={fullWidth}
        $removeMarginBottom={removeMarginBottom}
        data-testid="video-embed-wrapper"
      >
        {fullWidth && title && <Title>{title}</Title>}
        <VideoContainer>
          <VideoWrapper>
            <ReactPlayer
              url={externalUrl}
              config={{ ...options }}
              width="100%"
              height="100%"
              className="chromatic-ignore"
            />
            {title && <meta itemProp="name" content={title} />}
            {metaDescription && (
              <meta itemProp="description" content={metaDescription} />
            )}
            <meta itemProp="embedUrl" content={externalUrl} />
          </VideoWrapper>
        </VideoContainer>

        {fullWidth ? (
          <>
            {transcript && (
              <Transcript>
                <Accordion header="Video transcript">
                  <SimpleRichText richText={transcript} />
                </Accordion>
              </Transcript>
            )}
            {bottomText && (
              <BottomText>
                <SimpleRichText richText={bottomText} />
              </BottomText>
            )}
          </>
        ) : (
          <>
            <TextContainer>
              {!fullWidth && title && <Title>{title}</Title>}
              {bottomText && (
                <BottomText>
                  <SimpleRichText richText={bottomText} />
                </BottomText>
              )}
            </TextContainer>
            {transcript && (
              <Transcript>
                <Accordion header="Video transcript">
                  <SimpleRichText richText={transcript} />
                </Accordion>
              </Transcript>
            )}
          </>
        )}
      </Wrapper>
    </Container>
  );
};

VideoEmbed.propTypes = {
  title: PropTypes.string,
  bottomText: RichTextPropTypes,
  metaDescription: PropTypes.string,
  externalUrl: PropTypes.string.isRequired,
  removeMarginBottom: PropTypes.bool,
  transcript: RichTextPropTypes,
  fullWidthLayout: PropTypes.bool,
};

export default VideoEmbed;

export const VideoEmbedAssembly = ({ contentfulData }) => (
  <VideoEmbed
    title={contentfulData.title}
    bottomText={contentfulData.bottomText}
    metaDescription={contentfulData.metaDescription}
    externalUrl={contentfulData.externalUrl}
    removeMarginBottom={contentfulData.removeMarginBottom}
    transcript={contentfulData.transcript}
    fullWidthLayout={contentfulData.fullWidthLayout ?? true}
  />
);

VideoEmbedAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
